import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createPeopleInterest = (payload) => {
    return vdkEmHappinessPortalApi.post('/vdk-people-interests/create', payload);
};
const updatePeopleInterest = (payload) => {
    return vdkEmHappinessPortalApi.put('/vdk-people-interests/update', payload);
};
const deletePeopleInterest = (id) => {
    return vdkEmHappinessPortalApi.delete(`/vdk-people-interests/${id}`);
};
const getPeopleInterestById = (id) => {
    return vdkEmHappinessPortalApi.get(`/vdk-people-interests/${id}`);
};
const getPeopleInterestsByPeopleId = (payload) => {
    return vdkEmHappinessPortalApi.post('/peopleinterests/get-all', payload);
};
const PeopleInterestsApi = {
    createPeopleInterest,
    updatePeopleInterest,
    deletePeopleInterest,
    getPeopleInterestById,
    getPeopleInterestsByPeopleId
};
export default PeopleInterestsApi;
